// Normalisation de l'objet cartevitale renvoye par le backend.
// Le backend serialise les proprietes en PascalCase (Benef, Assure, Cbenef,
// Amofamille, Accidenttravail) alors que les vues lisent ces conteneurs en
// minuscule (benef, assure...). On expose les deux casses pour ne pas avoir a
// toucher chaque vue. Mutation en place : l'appelant recupere le meme objet.
const CONTENEURS = [
    ['Benef', 'benef'],
    ['Assure', 'assure'],
    ['Cbenef', 'cbenef'],
    ['Amofamille', 'amofamille'],
    ['Accidenttravail', 'accidenttravail'],
];

export function normaliserCarteVitale(carte) {
    if (!carte || typeof carte !== 'object') return carte;
    for (const [pascal, minuscule] of CONTENEURS) {
        if (carte[pascal] !== undefined && carte[minuscule] === undefined) {
            carte[minuscule] = carte[pascal];
        }
    }
    return carte;
}
